<template>
  <d2-container>
    <template slot="header">
      <el-input
        clearable
        @keyup.enter.native="getList"
        style="width: 200px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入海报名称"
        size="small"
        v-model="listQuery.keyword"
      ></el-input>
      <el-button @click="getList" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
    </template>
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="getAdd"
      v-permission:function="['posterManger:btn_add']"
    >添加</el-button>
    <el-table
      v-loading="listLoading"
      size="small"
      :key="tableKey"
      :data="list"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
    >
      <el-table-column align="center" label="id" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.id}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="海报名称">
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="280" fixed="right">
        <template slot-scope="scope">
          <el-button size="small" v-permission:function="['posterManger:btn_edit']" type="success" @click="getEdit(scope.row.id)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </template>
  </d2-container>
</template>
<script>
import { getPosterList } from '@/api/demo/poster/index'
export default {
  name: 'posterManger',
  data () {
    return {
      list: [],
      tableKey: 0,
      listLoading: false,
      posterManger_btn_add: false,
      posterManger_btn_edit: false,

      listQuery: {
        currentPage: 1,
        pageSize: 20,
        keyword: ''
      },
      total: 0
    }
  },
  watch: {
    watch: {
      $route (to, from) {
        console.log('to', to)
        if (to.path === '/demo/poster' && from.path === '/demo/poster/posterEditor') {
          this.getList(this.listQuery.currentPage)
        }
      }
    }
  },
  created () {
    this.getList()
  },
  mounted () {

  },
  methods: {
    getList (val) {
      let that = this
      if (typeof (val) !== 'object') {
        that.listQuery.currentPage = val
      } else {
        that.listQuery.currentPage = 1
      }
      that.listLoading = true
      getPosterList(that.listQuery).then(res => {
        that.list = res.records
        that.total = Number(res.total)
        that.listLoading = false
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getList(val)
    },
    getAdd () {
      this.$router.push({
        path: '/demo/poster/posterEditor'
      })
    },
    getEdit (id) {
      this.$router.push({
        path: './poster/posterEditor',
        query: {
          id: id
        }
      })
    }
  }
}
</script>
<style scoped>
</style>
